import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import * as firebase from "firebase";
import { HieroBDD } from "../../../services/hierobdd.service";
import { DocumentType } from "../../../../../common/src/bdd/documents/DocumentType";
import { LocalisationService } from "../../../../../common/src/modules/localisation/localisation.service";
import * as jsPDF from "jspdf";

import { Language } from "../../../../../common/src/bdd/utility/Language";

// for jspdf

let img = new Image();
img.src = "../assets/img/logo/fact.png";

var doc = new jsPDF();
var pageHeight =
  doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
var pageWidth = doc.internal.pageSize.width || doc.internal.pageSize.getWidth();

@Component({
  selector: "app-facture-detail",
  templateUrl: "./facture-detail.component.html",
  styleUrls: ["./facture-detail.component.scss"],
})
export class FactureDetailComponent implements OnInit {
  factureLoad: any[] = [];
  loadClientData: any;
  loadTraducteurData: any;
  traducteurName: string;
  tradId: string;
  traducteur: any[] = [];
  loadFullNameClient: any;
  loadFullNameTrad: any;
  @ViewChild("htmlDATA") htmlDATA: ElementRef;
  documentTypeMap: DocumentType;
  public product: String;
  public facture: any;
  public clientData: any;
  public traducteurData: any;
  private isPart: boolean = false;
  private proId: any;
  private partId: any;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private hiero: HieroBDD,
    private localisation: LocalisationService
  ) {}

  ngOnInit() {
    DocumentType.Init(this.hiero.Auth.User).then((types: DocumentType) => {
      this.documentTypeMap = types;
    });

    const id = this.activatedRoute.snapshot.paramMap.get("id");

    this.getTraducteurData().then((data) => {
      this.loadTraducteurData = data[0];
    });
    this.activatedRoute.paramMap.subscribe(async (paramMap) => {
      if (!paramMap.has("id")) {
        await this.router.navigate(["/facture"]);
      }
      const docID = paramMap.get("id");
      this.factureLoad = await this.getSingleFacture(docID);
      this.factureLoad.forEach((data) => {
        if (data.room) {
          this.product = data.room;
          console.log(this.product);
        } else {
          if (this.isPart) {
            const docRef = this.hiero.DB.collection("particuliers_commandes")
              .where("prestationId", "==", data.prestation)
              .get();
            docRef.then((snapshot) => {
              snapshot.docs.map((doc) => {
                this.product = doc.data().documentType;
              });
            });
          } else {
            const docRef = this.hiero.DB.collection("professionnel_commandes")
              .where("prestationId", "==", data.prestation)
              .get();
            docRef.then((snapshot) => {
              snapshot.docs.map((doc) => {
                this.product = doc.data().documentType;
              });
            });
          }
        }
      });
    });
  }

  async getSingleFacture(docID: string) {
    const db = firebase.firestore().collection("facture").doc(docID);
    const data = await db.get();
    let factures = [];
    if (data.data()) {
      this.isPart = false;
      this.proId = data.data().professionnelId;
      console.log(this.proId);

      factures.push(data.data());
    } else {
      this.isPart = true;
      const dbPart = firebase
        .firestore()
        .collection("facture_particuliers")
        .doc(docID);
      const dataPart = await dbPart.get();
      this.partId = dataPart.data().particulierId;
      factures.push(dataPart.data());
    }

    this.getClientData().then((data) => {
      this.loadClientData = data;
    });

    return factures;
  }

  async getClientData() {
    if (!this.isPart) {
      const docRef = this.hiero.DB.collection("professionnels").doc(this.proId);
      const data = await docRef.get();
      this.getFullNameClient(data.data().uid).then((data) => {
        console.log(data);

        this.loadFullNameClient = data;
      });
      return data.data();
    } else {
      const docRef = this.hiero.DB.collection("particuliers").doc(this.partId);
      const data = await docRef.get();
      this.getFullNameClient(data.data().uid).then((data) => {
        console.log(data);

        this.loadFullNameClient = data;
      });
      return data.data();
    }
  }

  async getTraducteurData() {
    const currentUser = firebase.auth().currentUser;
    const docRef = this.hiero.DB.collection("traducteurs").where(
      "uid",
      "==",
      currentUser.uid
    );

    const snapshot = await docRef.get();
    return snapshot.docs.map((doc) => {
      this.getFullNameTrad(doc.data().uid).then((data) => {
        this.loadFullNameTrad = data;
      });
      return doc.data();
    });
  }

  getDocumentName(docIdType: string) {
    if (this.documentTypeMap) {
      return this.documentTypeMap.GetDocumentName(
        this.localisation.CurrentLanguageISO639,
        docIdType
      );
    } else {
      return "";
    }
  }

  /* getFullNamePro() {
    const currentUser = this.hiero.Auth.User;
    const docRef = this.hiero.DB.collection("professionnels").where(
      "uid",
      "==",
      currentUser.Id
    );
    return docRef.get().then((snaphot) => {
      return snaphot.docs.map((doc) => {
        return this.hiero.DB.collection("users")
          .get()
          .then((snap) => {
            return snap.docs.map((el) => {
              if (el.id === doc.data().uid) {
                this.loadFullNamePro.push(el.data());
              }
              return this.loadFullNamePro;
            });
          });
      });
    });
  } */

  async getFullNameClient(uid: string) {
    const docRef = this.hiero.DB.collection("users").doc(uid);
    const data = await docRef.get();
    return data.data();
  }

  async getFullNameTrad(uid: string) {
    const docRef = this.hiero.DB.collection("users").doc(uid);
    const data = await docRef.get();
    return data.data();
  }

  public download(param) {
    var doc = new jsPDF();

    // ####### Adresse de Hiero
    doc.setFontSize(12);
    doc.setFontType("bold");
    doc.text(this.loadTraducteurData.businessName, 10, 10);

    doc.setFontSize(10);
    doc.setFontType("normal");
    doc.text(
      this.loadTraducteurData.address.number +
        " " +
        this.loadTraducteurData.address.street,
      10,
      15
    );
    doc.text(
      this.loadTraducteurData.address.code +
        " " +
        this.loadTraducteurData.address.city +
        " " +
        this.loadTraducteurData.address.country,
      10,
      20
    );
    doc.text(this.loadTraducteurData.telephone, 10, 25);
    doc.text(this.loadTraducteurData.email, 10, 30);

    //##### Logo

    doc.addImage(img, "png", 150, 10, 50, 50);

    // ##### Titre facture
    doc.setTextColor("#00acac");
    doc.setFontSize(20);
    doc.setFontType("bold");
    doc.text(this.localisation.localise("head_facture").toUpperCase(), 10, 70);
    doc.setFontType("normal");
    doc.setTextColor(255, 0, 0);
    doc.setFontSize(30);

    // Infos sous le titre de la facture:
    doc.setTextColor("black");
    doc.setFontSize(10);
    doc.setFontType("bold");
    doc.text(
      this.localisation.localise("facture_numero").toUpperCase(),
      20,
      80
    );
    doc.text(this.localisation.localise("section_date").toUpperCase(), 20, 85);
    doc.text(
      this.localisation.localise("facture_echeance").toUpperCase(),
      20,
      90
    );
    doc.text(
      this.localisation.localise("facture_conditions").toUpperCase(),
      20,
      95
    );

    doc.setFontType("normal");

    doc.text(`${this.factureLoad[0].numero}`, 50, 80);
    doc.text(
      new Date(this.factureLoad[0].date.seconds * 1000).toLocaleDateString(
        "fr-FR"
      ),
      50,
      85
    );
    doc.text(
      new Date(this.factureLoad[0].date.seconds * 1000).toLocaleDateString(
        "fr-FR"
      ),
      50,
      90
    );
    doc.text(this.localisation.localise("facture_comptant"), 50, 95);

    // ADRESSE DE FACTURATION

    doc.setFontType("bold");
    doc.text(
      this.localisation.localise("facture_adress").toUpperCase(),
      130,
      80
    );
    doc.setFontType("normal");
    doc.text(
      this.loadFullNameClient.profile.familyName +
        " " +
        this.loadFullNameClient.profile.givenName,
      130,
      87
    );
    if (!this.isPart)
      doc.text(this.localisation.localise("facture_pro"), 130, 92);
    else doc.text(this.localisation.localise("facture_part"), 130, 92);
    doc.text(
      this.loadClientData.address.number +
        " " +
        this.loadClientData.address.street,
      130,
      97
    );
    doc.text(
      this.loadClientData.address.code + " " + this.loadClientData.address.city,
      130,
      102
    );
    doc.text(this.loadClientData.address.country, 130, 107);

    // Ligne horizontal
    doc.setDrawColor("#00acac");
    doc.line(pageWidth - 20, 120, 20, 120);
    // doc.line(190, 151, 30, 151);

    // ####### Le tableau

    // # En tête
    doc.setFillColor(0, 172, 172);

    doc.rect(20, 125, pageWidth - 40, 10, "F");

    doc.setTextColor("#FFFFFF");

    doc.text(this.localisation.localise("facture_qte").toUpperCase(), 21, 131);

    doc.text(
      this.localisation.localise("commande_produit").toUpperCase(),
      33,
      131
    );

    doc.text(
      this.localisation.localise("commande_desc").toUpperCase(),
      73,
      131
    );

    doc.text(
      this.localisation.localise("tasks_price_tva").toUpperCase(),
      127,
      131
    );

    doc.text(
      this.localisation.localise("facture_price").toUpperCase(),
      147,
      129
    );
    doc.text(
      this.localisation.localise("facture_unitaire").toUpperCase(),
      147,
      133
    );

    doc.text(
      this.localisation.localise("facture_montant").toUpperCase(),
      171,
      131
    );

    // # La data

    doc.setTextColor("black");

    doc.text(
      `${
        this.factureLoad[0].pagesNumber ? this.factureLoad[0].pagesNumber : 1
      }`,
      21,
      143
    ); //  QTE

    console.log(this.product);

    doc.text(this.product, 33, 143); //  Product
    let type: string = "";
    if (this.factureLoad[0].typePrestation === "Interprétation")
      type = this.localisation.localise("interpretation");
    if (this.factureLoad[0].typePrestation === "Traduction assermentée")
      type = this.localisation.localise("traduction_assermentee");
    if (this.factureLoad[0].typePrestation === "Traduction classique")
      type = this.localisation.localise("traduction_classic");
    doc.text(
      type +
        " " +
        this.localisation.localise("prestation_order_from").toLowerCase() +
        "\n " +
        Language.GetNameFromISO639(this.factureLoad[0].srcLang).toLowerCase() +
        " " +
        this.localisation.localise("order_language_to").toLowerCase() +
        " " +
        Language.GetNameFromISO639(this.factureLoad[0].destLang).toLowerCase(),
      73,
      143
    ); // Description (faire la gestion de l'espace direcetement avec substr() et \n)

    if (this.loadTraducteurData.assujettiTVA) doc.text("20 %", 127, 143); // TVA
    else doc.text("0 %", 127, 143); // TVA

    doc.text(
      (
        this.factureLoad[0].priceHT.toFixed(2) /
        (this.factureLoad[0].pagesNumber ? this.factureLoad[0].pagesNumber : 1)
      ).toFixed(2),
      152,
      143
    ); // Question par rapport au Prix Unitaire

    doc.text(this.factureLoad[0].priceHT.toFixed(2), pageWidth - 30, 143); // Montant total

    doc.setDrawColor("#00acac");
    // doc.line(190, 185, 30, 185);
    doc.line(pageWidth - 20, 155, 20, 155);

    // ##### Table des totaux
    //# Col 1

    doc.text(this.localisation.localise("total_ht").toUpperCase(), 127, 165);
    doc.text(this.localisation.localise("total_tva").toUpperCase(), 127, 175);
    doc.text(this.localisation.localise("total_ttc").toUpperCase(), 127, 185);

    // # Col 2

    doc.text(this.factureLoad[0].priceHT.toFixed(2), pageWidth - 30, 165);
    if (this.loadTraducteurData.assujettiTVA)
      doc.text(this.factureLoad[0].priceTVAVal.toFixed(2), pageWidth - 30, 175);
    else doc.text("0.00", pageWidth - 30, 175);

    doc.setTextColor("#00acac");
    doc.setFontSize(15);
    doc.setFontType("bold");
    if (this.loadTraducteurData.assujettiTVA)
      doc.text(this.factureLoad[0].priceTTC.toFixed(2) + " " + "EUR", 165, 185);
    else
      doc.text(this.factureLoad[0].priceHT.toFixed(2) + " " + "EUR", 165, 185);

    doc.setFontType("normal");

    // Recap TVA
    doc.setFontSize(12);
    doc.setTextColor("black");
    doc.text(this.localisation.localise("recap_tva").toUpperCase(), 20, 208);
    doc.setFontSize(10);

    // doc.text('MONTANT DE TVA', )

    // doc.text('BASE HT', )

    // doc.text()

    doc.setTextColor("black");

    // Lignes inférieures

    // doc.setDrawColor('#00acac')
    // doc.line(30, 230, 190, 230)
    // doc.line(20, 201, pageWidth-20, 201)
    doc.setFillColor(0, 172, 172);

    doc.rect(20, 211, pageWidth - 40, 10, "F");

    doc.setTextColor("#FFFFFF");
    doc.text(this.localisation.localise("recap_taux").toUpperCase(), 30, 217);
    doc.text(this.localisation.localise("recap_mt_tva").toUpperCase(), 90, 217);
    doc.text(
      this.localisation.localise("recap_base_ht").toUpperCase(),
      170,
      217
    );

    doc.setTextColor("black");

    if (this.loadTraducteurData.assujettiTVA)
      doc.text(
        this.localisation.localise("facture_tva_fr").toUpperCase(),
        25,
        227
      );
    else doc.text("0 %", 25, 227);

    if (this.loadTraducteurData.assujettiTVA)
      doc.text(this.factureLoad[0].priceTVAVal.toFixed(2), 100, 227);
    else doc.text("0.00", 100, 227);
    doc.text(this.factureLoad[0].priceHT.toFixed(2), 179, 227);

    // Pénalité et etc...
    doc.setFontType("normal");
    doc.setFontSize(10);

    doc.setTextColor("black");
    doc.text(
      this.localisation.localise("condition_paragraphe_1"),
      pageWidth / 2,
      245,
      {
        align: "center",
      }
    );
    doc.text(
      this.localisation.localise("condition_paragraphe_2"),
      pageWidth / 2,
      250,
      {
        align: "center",
      }
    );
    doc.text(
      this.localisation.localise("condition_paragraphe_3"),
      pageWidth / 2,
      255,
      { align: "center" }
    );

    // Footer

    doc.setDrawColor("#00acac");
    doc.line(0, pageHeight - 16, pageWidth, pageHeight - 16);
    doc.setFontSize(8);
    doc.text(
      this.localisation.localise("capital_sasu") +
        " - " +
        this.localisation.localise("agency_address_number") +
        " " +
        this.localisation.localise("rcs_infos") +
        " - " +
        this.localisation.localise("agency_address_number") +
        " " +
        this.localisation.localise("siret") +
        " - " +
        this.localisation.localise("agency_address_number") +
        " " +
        this.localisation.localise("tva_fr"),
      pageWidth / 2,
      pageHeight - 10,
      { align: "center" }
    );

    if (param === 1) {
      doc.autoPrint();
      //This is a key for printing
      doc.output("dataurlnewwindow");
    } else {
      //Save the PDF
      doc.save("Facture_" + this.factureLoad[0].numero);
    }
  }
}
